var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document"},[_c('iframe',{attrs:{"src":"/docs/AndroidNew.html","frameborder":"0","sandbox":"allow-scripts"}})])
}]

export { render, staticRenderFns }